import React from 'react';
import PropTypes from 'prop-types';

function EmojiIcon({ name, version, className = '' }) {
    return (
        <span
            className={`emoji-${version} emoji-${version}-${name} ${className}`.trim()}
            aria-hidden='true'
        />
    );
}

EmojiIcon.propTypes = {
    name: PropTypes.string.isRequired,
    version: PropTypes.string.isRequired,
    className: PropTypes.string
};

export {
    EmojiIcon
};
